export default __webpack_public_path__ + "static/media/drum.b404244c.png";